<plugin-preview-chrome
  [config]="config"
  [zipCodeAvailableControl]="zipCodeAvailableControl"
  [themeEditorUrl]="themeEditorUrl">
  <ng-template>
    <div class="advanced-preview-body">
      @for (component of config?.advancedLayoutSettings?.components ?? []; track component.id) {
        @if (component.enabled) {
          @switch (component.type) {
            @case (LayoutComponentType.LABEL) {
              <label-component-preview [options]="component.options"></label-component-preview>
            }
            @case (LayoutComponentType.DELIVERY_DATE) {
              <delivery-date-component-preview
                [options]="component.options"
                [zipCodeAvailable]="zipCodeAvailableControl.value"
                [linkedCutoffOptions]="linkedCutoffOptions"></delivery-date-component-preview>
            }
            @case (LayoutComponentType.SHIPPING_METHOD_LINE) {
              <shipping-method-line-component-preview
                [options]="component.options"
                [zipCodeAvailable]="zipCodeAvailableControl.value"></shipping-method-line-component-preview>
            }
            @case (LayoutComponentType.LOCATION_INPUT) {
              <location-input-component-preview
                [options]="component.options"
                [zipCodeAvailable]="zipCodeAvailableControl.value"></location-input-component-preview>
            }
            @case (LayoutComponentType.LINE_SEPARATOR) {
              <line-separator-component-preview></line-separator-component-preview>
            }
            @case (LayoutComponentType.CUTOFF_TIMER) {
              @if (component.options?.position === CutoffTimerPosition.STANDALONE) {
                <cutoff-timer-component-preview
                  [options]="component.options"
                  [zipCodeAvailable]="zipCodeAvailableControl.value"></cutoff-timer-component-preview>
              }
            }
            @case (LayoutComponentType.TRUST_SIGNALS) {
              <trust-signals-component-preview [options]="component.options"></trust-signals-component-preview>
            }
          }
        }
      }
    </div>
  </ng-template>
</plugin-preview-chrome>
